import { getStoreId } from "$/hooks/use-store-information"
import serviceSettingsQueries from "$/lib/queries/service-settings-queries"
import storeQueries from "$/lib/queries/store-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/bikes-for-sale")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(serviceSettingsQueries.detail(storeId))
      queryClient.prefetchQuery(storeQueries.detail(storeId))
    }
    return { crumbs: "alfred.settings.nav.bikesForSale.label" }
  },
})
